"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullImageSavePath = void 0;
const crypto = require("crypto");
const os = require("os");
const path = require("path");
function fullImageSavePath(imageSavePath) {
    let imagePath = os.tmpdir();
    if (imageSavePath) {
        imagePath = path.normalize(imageSavePath);
    }
    return path.join(imagePath, crypto.randomUUID());
}
exports.fullImageSavePath = fullImageSavePath;
//# sourceMappingURL=image-save-path.js.map